import Joi from 'joi';

/**
 * Schema for rental-reservations: status can only be changed if current status is 'pending',
 * and newStatus is different from current status.
 * @param newStatus - The new status to validate against.
 * @returns - The Joi schema for validation.
 */
export const setReservationStatusSchema = (newStatus: string) => {
  return Joi.object({
    status: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|set-status|cannot-be-null',
        }),
        otherwise: Joi.string()
          .required()
          .custom((value, helpers) => {
            if (value !== 'pending') {
              return helpers.error('any.only', { value });
            }
            if (value === newStatus) {
              return helpers.error('any.invalid', { value });
            }
            return value;
          })
          .messages({
            'any.only': 'validations|set-status|can-only-change-from-pending',
            'any.invalid': `validations|set-status|status-is-already-${newStatus.toLowerCase()}`,
            'any.required': 'validations|set-status|required',
          }),
      })
      .required()
      .messages({
        'any.required': 'validations|set-status|required',
      }),
  }).unknown(true);
};
